"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { HiOutlineChevronDown } from "react-icons/hi2";
import styles from "./style.module.css";

import MainTitle from "@/common/MainTitle/MainTitle";

function MobileView({ title, heroColumns }) {
  const [currentVisibleItem, setCurrentVisibleItem] = useState(-1);

  return (
    <div className={`container ${styles.container}`}>
      <MainTitle>{title}</MainTitle>

      {heroColumns.map((column, index) => (
        <motion.div
          className={`descriptiveGrid ${styles.itemContainer}`}
          key={`mobile-${column._key}`}
          onClick={() => {
            if (currentVisibleItem === index) {
              setCurrentVisibleItem(-1);
            } else {
              setCurrentVisibleItem(index);
            }
          }}
        >
          <div className={styles.item}>
            <h3 className="descriptiveGrid--title">
              <span>{column.heroColumnTitle}</span>
              <motion.span
                className="flexCenter"
                animate={{
                  transform:
                    currentVisibleItem === index
                      ? "rotate(180deg)"
                      : "rotate(0)",
                }}
              >
                <HiOutlineChevronDown />
              </motion.span>
            </h3>
          </div>
          {currentVisibleItem === index && (
            <p>{column.heroColumnDescription}</p>
          )}
        </motion.div>
      ))}
    </div>
  );
}

export default MobileView;
